'use strict';
var parent = require('../../stable/symbol/dispose');
require('../../modules/esnext.symbol.dispose');

module.exports = parent;
